<template>
  <div class="wishcard">
    <div
      v-if="cards.length > 0"
      class="wishcard__selection"
    >
      <tg-form-select
        name="select-card"
        class="wishcard__input-select"
        :value="card ? card.id : null"
        :items="selectCardOptions"
        item-text="name"
        item-value="id"
        @input="onInput"
      />
      <tg-form-radio-group
        name="radio-card"
        class="wishcard__input-radio-group"
        :value="card ? card.id : null"
        :inline="true"
        :choices="cards"
        item-label="name"
        item-value="id"
        @input="onInput"
      />
      <input type="hidden" name="card" :value="card ? card.id : ''"/>
    </div>
    <div class="wishcard__display">
      <tg-wishcard-small
        v-if="card && card.size === 'small'"
        :card="card"
        :card-text="cardText || ''"
      />
      <tg-wishcard-big
        v-else-if="card"
        :card="card"
        :card-text="cardText || ''"
        :siteThumbnail="siteThumbnail"
      />
    </div>
  </div>
</template>

<script>
import TgFormSelect from '@topgeschenken/webshop-front/components/common/form/fields/TgFormSelect'
import TgFormRadioGroup from '@topgeschenken/webshop-front/components/common/form/fields/TgFormRadioGroup'
import TgWishcardSmall from './TgWishcardSmall'
import TgWishcardBig from './TgWishcardBig'

export default {
  name: 'TgWishcard',

  components: {
    TgFormSelect,
    TgFormRadioGroup,
    TgWishcardSmall,
    TgWishcardBig,
  },

  data() {
    return {
      card: null
    }
  },

  props: {
    cards: {
      type: Array,
      required: true
    },
    cardId: {
      // type: [Number, null], // Gives issues at the moment
      required: true,
      default: null
    },
    cardText: {
      type: String,
      required: true,
      default: ''
    },
    siteThumbnail: {
      // type: [String, null], // Gives issues at the moment
      required: true,
      default: ''
    }
  },

  computed: {
    selectCardOptions() {
      return [
        {id: null, name: this.$t('wishcard.choose_a_card')},
        ...this.cards
      ]
    },
  },

  methods: {
    findCurrentCardInList(cardId) {
      return this.cards.filter((card) => {
        return card.id === cardId
      })[0] ?? this.cards[0]
    },

    onInput(value) {
      this.card = this.findCurrentCardInList(parseInt(value))
    }
  },

  mounted() {
    this.card = this.findCurrentCardInList(this.$props.cardId)
  }
}
</script>

<style scoped>
.wishcard {
  margin-bottom: 1rem;
}

.wishcard__input-select {
  margin-bottom: 1rem !important;
}

.wishcard >>> .radio-group__list {
  display: flex;
  flex-wrap: wrap;
}

.wishcard >>> .radio-group__item {
  width: calc(33.333% - 1rem);
  margin: 0 0 .5rem;
}

.wishcard__input-radio-group {
  display: none;
}

@media (min-width: 992px) {
  .wishcard__input-select {
    display: none;
  }

  .wishcard__input-radio-group {
    display: block;
  }
}
</style>
